module.exports = __webpack_public_path__ + "assets/img/1.8dbde870.webp";